import React from 'react';
import { OneWayInOpportunitySimpleV2Dto } from 'src/api/v2';
import { Skeleton } from '@innovationnorway/cl-react';
import AdvisorButton from './AdvisorButton';
import AdvisorDropdownPanel from './AdvisorDropdownPanel';

/**
 * Advisor button that swaps in the heavy assignment panel on first click. Display values are passed
 * in rather than looked up, so list items don't each register their own user/permission queries.
 */
const AdvisorControl = ({
  opportunity,
  initials,
  colorClass,
  label,
  isLoading,
}: {
  opportunity: Pick<OneWayInOpportunitySimpleV2Dto, 'id' | 'oneWayInId' | 'assignedTo' | 'clusterId'>;
  initials: string | undefined;
  colorClass: string;
  label: string;
  isLoading?: boolean;
}) => {
  const [hasOpened, setHasOpened] = React.useState(false);

  const dropdownId = `advisor-assignment-${opportunity.id}`;

  if (hasOpened) {
    return <AdvisorDropdownPanel opportunity={opportunity} dropdownId={dropdownId} />;
  }

  if (isLoading) {
    return <Skeleton width="43px" height="43px" />;
  }

  return (
    <AdvisorButton
      dropdownId={dropdownId}
      initials={initials}
      colorClass={colorClass}
      label={label}
      onClick={() => setHasOpened(true)}
    />
  );
};

export default AdvisorControl;
